var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 0.375H1.6207C0.864453 0.375 0.25 0.998047 0.25 1.76289V18.2371C0.25 19.002 0.864453 19.625 1.6207 19.625H18.125C18.8813 19.625 19.5 19.002 19.5 18.2371V1.76289C19.5 0.998047 18.8813 0.375 18.125 0.375ZM6.06797 16.875H3.21484V7.68828H6.07227V16.875H6.06797ZM4.64141 6.43359C3.72617 6.43359 2.98711 5.69023 2.98711 4.7793C2.98711 3.86836 3.72617 3.125 4.64141 3.125C5.55234 3.125 6.2957 3.86836 6.2957 4.7793C6.2957 5.69453 5.55664 6.43359 4.64141 6.43359V6.43359ZM16.7629 16.875H13.9098V12.4062C13.9098 11.3406 13.8883 9.96992 12.4273 9.96992C10.9406 9.96992 10.7129 11.1301 10.7129 12.3289V16.875H7.85977V7.68828H10.5969V8.94297H10.6355C11.018 8.22109 11.9504 7.46055 13.3383 7.46055C16.2258 7.46055 16.7629 9.36406 16.7629 11.8391V16.875V16.875Z",
    fill: "url(#paint0_linear_561_725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_725",
    x1: 19.5,
    y1: 0.375,
    x2: 0.25,
    y2: 0.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8468BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.a655fd99580e1615c7797be510e027db.svg";
export { ForwardRef as ReactComponent };